import EnTabs from './tabs'

const components = {
  EnTabs
}
components.install = function (Vue, opts) {
  Object.keys(components).forEach(key => {
    key !== 'install' && Vue.component(components[key].name, components[key])
  })
}
export {
  EnTabs
}

export default components



// WEBPACK FOOTER //
// ./src/components/index.js